const OVERLAY_SIZE_UNITS = {
    PIXEL: 'PIXEL',
    PERCENT: 'PERCENT',
};
export default OVERLAY_SIZE_UNITS;
//# sourceMappingURL=behaviourParams_item_overlay_sizeUnits.js.map